<template>
  <v-dialog
    v-model="getModalPagamentoOrdemServico"
    persistent
  >
    <v-card>
      <v-card-title>Pagamento</v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-form ref="formFormaPagamento">
              <v-layout row wrap class="mr-2 ml-2 mt-8">
                <v-flex xs12 md8>
                  <v-select
                    label="Forma de Pagamento"
                    :items="getFormasPagamento"
                    v-model="formaPagamentoSelecionada"
                    return-object
                    outlined
                    dense
                    item-text="id"
                    item-value="id"
                    class="mr-1 ml-1"
                    id="inputFormaPagamento"
                    :rules="rules.formaPagamentoSelecionada"
                    :hide-selected="true"
                    @keyup.13="focus('inputValorPago')"
                    @input="verificarAcrescimo($event)"
                    no-data-text="Forma de pagamento não encontrada."
                  >
                    <template v-slot:item="{ item }">
                      {{ item.id }} - {{ item.nome }}
                    </template>
                    <template v-slot:selection="{ item }">
                      {{ item.id }} - {{ item.nome }}
                    </template>
                  </v-select>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-if="formaPagamentoSelecionada.id"
                    dense
                    outlined
                    type="text"
                    v-model="formaPagamentoSelecionadaValor"
                    label="Valor Pago"
                    @keyup.13="
                      formaPagamentoSelecionada.prazo
                        ? focus('inputRecorrencia')
                        : adicionaPagamento()
                    "
                    :rules="rules.formaPagamentoSelecionadaValor"
                    id="inputValorPago"
                    class="mr-1 ml-1"
                    v-mask="[
                      '#,##',
                      '##,##',
                      '###,###',
                      '#.###,##',
                      '##.###,##',
                      '###.###,##',
                    ]"
                    @click="$event.target.select()"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md8>
                  <v-autocomplete
                    v-model="bandeira_cartao"
                    :items="formaPagamentoSelecionada.bandeiras_cartao"
                    v-if="formaPagamentoSelecionada.bandeiras_cartao"
                    item-text="nome"
                    item-value="id"
                    class="mr-1 ml-1"
                    outlined
                    dense
                    label="Bandeira do Cartão"
                    :rules="rules.bandeira_cartao"
                    return-object
                  />
                </v-flex>

                <v-flex xs12 md3>
                  <v-autocomplete
                    v-model="numero_parcelas"
                    :items="numero_parcelas_opcoes"
                    v-if="numero_parcelas_opcoes.length > 0"
                    item-text="nome"
                    item-value="id"
                    class="mr-1 ml-1"
                    outlined
                    dense
                    :rules="rules.numero_parcelas"
                    label="Quant. de Parcelas"
                    @keyup.13="adicionaPagamento"
                  />
                </v-flex>
                <v-flex xs12 md8>
                  <v-autocomplete
                    v-model="formaPagamentoSelecionada.recorrencia"
                    :items="getRecorrenciasFormaPagamento"
                    :rules="rules.recorrencia"
                    item-text="descricao"
                    item-value="dias"
                    label="Recorrência"
                    v-if="formaPagamentoSelecionada.prazo"
                    id="inputRecorrencia"
                    outlined
                    dense
                    class="mr-1 ml-1"
                    @keyup="focus('inputNumeroParcelasPrazo', event)"
                    return-object
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    label="Número de Parcelas"
                    outlined
                    dense
                    v-model="numero_parcelas"
                    :rules="rules.numero_parcelas"
                    id="inputNumeroParcelasPrazo"
                    class="mr-1 ml-1"
                    type="number"
                    @keyup.enter="adicionaPagamento"
                    v-if="formaPagamentoSelecionada.prazo"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <ul>
                    <li v-for="f in getFormasPagamento" :key="f.id">
                      {{ f.id }} - {{ f.nome }}
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
          <v-flex xs12 md6>
            <!-- <v-simple-table
              fixed-header
              v-if="ordemServico.formas_pagamento.length > 0"
            >
              <template v-slot:default>
                <tbody>
                  <tr v-for="f in ordemServico.formas_pagamento" :key="f.id">
                    <td class="display-1" width="50%">{{ f.forma }}</td>
                    <td class="display-1" width="50%">
                      {{ $helper.formatReal(parseFloat(f.valor_pago)) }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table> -->

            <v-simple-table fixed-header class="mt-10">
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td class="display-1" width="50%">SUBTOTAL</td>
                    <td class="display-1" width="50%">
                      <!-- {{
                        $helper.formatReal(
                          $helper.cleanFormatReal(getOrdemServico.subtotal) +
                            $helper.cleanFormatReal(getOrdemServico.desconto) -
                            getOrdemServico.acrescimo
                        )
                      }} -->

                      {{getOrdemServico.subtotal}}
                    </td>
                  </tr>
                  <tr>
                    <td class="display-1" width="50%">ACRÉSCIMO</td>
                    <td class="display-1" width="50%">
                      {{
                        $helper.formatReal(
                          parseFloat(getOrdemServico.acrescimo)
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td class="display-1" width="50%">DESCONTO</td>
                    <td class="display-1" width="50%">
                      {{ getOrdemServico.desconto }}
                    </td>
                  </tr>
                  <tr>
                    <td class="display-1" width="50%">TOTAL</td>
                    <td class="display-1" width="50%">
                      {{ getOrdemServico.total }}
                    </td>
                  </tr>
                  <tr>
                    <td class="display-1" width="50%">PAGO</td>
                    <td class="display-1" width="50%">
                      {{ $helper.formatReal(parseFloat(valorPago)) }}
                    </td>
                  </tr>
                  <tr v-if="valorFaltando > 0">
                    <td class="display-1" width="50%">FALTA</td>
                    <td class="display-1" width="50%">
                      {{ $helper.formatReal(parseFloat(valorFaltando)) }}
                    </td>
                  </tr>
                  <tr v-if="getOrdemServico.troco > 0">
                    <td class="display-1" width="50%">TROCO</td>
                    <td class="display-1" width="50%">
                      {{
                        $helper.formatReal(parseFloat(getOrdemServico.troco))
                      }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="warning"
          outlined
          dense
          @click="modalCancelarFechamento = true"
          >Cancelar Fechamento</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn color="success" @click="adicionaPagamento" outlined
          >Confirmar Fechamento</v-btn
        >
      </v-card-actions>
    </v-card>
  

    <v-dialog v-model="modalSalvar" max-width="720">
      <v-card>
        <v-card-title>Fechar</v-card-title>
        <v-card-text>
          <h1 align="center" v-if="getOrdemServico.troco > 0">
            TROCO: {{ $helper.formatReal(parseFloat(getOrdemServico.troco)) }}
          </h1>
          <h3 align="center" class="mt-4">
            Tem certeza que deseja fechar esta venda?
          </h3>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            @click="cancelarFechamento(), (modalSalvar = false)"
            outlined
            :loading="$store.getters.getOverlay"
            >Não (N)</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="salvarPagamento()"
            @dblclick="salvarPagamento()"
            outlined
            :loading="$store.getters.getOverlay"
            >Sim (S)</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="modalCancelarFechamento" persistent max-width="720px">
        <v-card outlined>
          <v-card-title>Cancelar Fechamento</v-card-title>
          <v-card-text>
            <h3 align="center">
              Os valores lançados serão apagados, tem certeza que deseja
              cancelar?
            </h3>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="default"
              outlined
              @click="modalCancelarFechamento = false"
              >Não (N)</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="warning"
              outlined
              @click="cancelarFechamento(), (modalFechamento = false)"
            >
              Sim (S)</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      modalSalvar: false,
      valorFaltando: 0,
      modalCancelarFechamento: false,
      formaPagamentoSelecionada: {},
      formaPagamentoSelecionadaValor: "0,00",
      numero_parcelas: "",
      ordemServico: {
        formas_pagamento: []
      },
      rules: {
        nome: [(v) => !!v || "Campo obrigatório."],
        formaPagamentoSelecionada: [(v) => !!v || "Campo obrigatório."],
        formaPagamentoValor: [(v) => !!v || "Campo obrigatório."],
        bandeira_cartao: [(v) => !!v || "Campo obrigatório."],
        numero_parcelas: [(v) => !!v || "Campo obrigatório."],
        recorrencia: [(v) => !!v || "Campo obrigatório."],
      },
      numero_parcelas_opcoes: [],
      modalFechamento: false,
      valorPago: 0,
      bandeira_cartao: "",
    };
  },
  watch: {
    formaPagamentoSelecionada: function () {
      this.numero_parcelas_opcoes = [];
      this.bandeira_cartao = "";
      this.numero_parcelas = "";
    },
    bandeira_cartao: function () {
      this.numero_parcelas_opcoes = [];
      for (
        let index = 1;
        index <= this.bandeira_cartao.numero_maximo_parcelas;
        index++
      ) {
        this.numero_parcelas_opcoes.push(index);
      }
    },
  },
  computed: {
    ...mapGetters([
      "getOrdemServico",
      "getModalPagamentoOrdemServico",
      "getFormasPagamento",
      "getRecorrenciasFormaPagamento",
    ]),
  },
  methods: {
    ...mapActions(["setModalPagamentoOrdemServico", "listarFormaPagamento", "salvarPagamentoOrdemServico"]),
    salvarPagamento(){
      this.modalSalvar = false
      const data = {
        troco: this.$helper.formatReal(parseFloat(this.getOrdemServico.troco)),
        acrescimo: this.$helper.formatReal(parseFloat(this.getOrdemServico.acrescimo)),
        ordem_servico_id: this.getOrdemServico.id,
        formas_pagamento: {
          ...this.ordemServico.formas_pagamento,
        }
      }
      
      this.salvarPagamentoOrdemServico(data)
    },
    adicionaPagamento() {
      if (this.$refs.formFormaPagamento.validate() == false) {
        return;
      }

      this.valorFaltando = 0;
      if (
        !this.formaPagamentoSelecionadaValor ||
        this.formaPagamentoSelecionadaValor == "" ||
        this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) <= 0
      ) {
        this.$store.commit("snackbarWarning", "Informe o valor pago");
        return;
      }

      if (
        (this.formaPagamentoSelecionada.prazo &&
          this.getOrdemServico.cliente_id == "") ||
        (this.formaPagamentoSelecionada.prazo &&
          this.getOrdemServico.cliente_id == null) ||
        (this.formaPagamentoSelecionada.prazo &&
          this.getOrdemServico.cliente_id == 1)
      ) {
        this.$store.commit(
          "snackbarWarning",
          "Informe um cliente para esta forma de pagamento."
        );
        this.formaPagamentoSelecionada = "";
        return;
      }

      if (this.formaPagamentoSelecionada.prazo && this.numero_parcelas < 1) {
        this.$store.commit("snackbarWarning", "Informe o número de parcelas.");
        return;
      }

      this.valorPago += this.$helper.cleanFormatReal(
        this.formaPagamentoSelecionadaValor
      );

      if (
        this.valorPago >=
        this.$helper.cleanFormatReal(this.getOrdemServico.total)
      ) {
        this.getOrdemServico.troco = 0;
        this.getOrdemServico.troco +=
          this.valorPago -
          this.$helper.cleanFormatReal(this.getOrdemServico.total);
        this.modalSalvar = true;
      }

      if (
        this.valorPago <
        this.$helper.cleanFormatReal(this.getOrdemServico.total)
      ) {
        this.valorFaltando +=
          this.$helper.cleanFormatReal(this.getOrdemServico.total) -
          this.valorPago;
      }

      if (
        this.valorPago >
        this.$helper.cleanFormatReal(this.getOrdemServico.total)
      ) {
        // this.trocoFormaPagamento = this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) - this.$helper.cleanFormatReal(this.getOrdemServico.total)
        this.formaPagamentoSelecionadaValor = this.$helper.formatReal(
          this.$helper.cleanFormatReal(this.formaPagamentoSelecionadaValor) -
            this.getOrdemServico.troco
        );
      }

      // return
      const data = {
        forma: this.formaPagamentoSelecionada.nome,
        valor_pago: this.formaPagamentoSelecionadaValor,
        troco: this.getOrdemServico.troco,
        forma_pagamento_id: this.formaPagamentoSelecionada.id,
        prazo: this.formaPagamentoSelecionada.prazo,
        bandeira_cartao: this.bandeira_cartao
          ? this.bandeira_cartao.nome
          : null,

        numero_parcelas: this.numero_parcelas ? this.numero_parcelas : null,
        recorrencia: this.formaPagamentoSelecionada.recorrencia
          ? this.formaPagamentoSelecionada.recorrencia.dias
          : null,
        ocorrencia: this.formaPagamentoSelecionada.recorrencia
          ? this.formaPagamentoSelecionada.recorrencia.descricao
          : null,
      };

      if (this.valorPago > 0) {
        if (data.forma_pagamento_id) {
          this.ordemServico.formas_pagamento.push(data);
        }
      }

      this.formaPagamentoSelecionada = {};
      this.formaPagamentoSelecionadaValor = "0,00";
      document.getElementById("inputFormaPagamento").focus();
      this.trocoFormaPagamento = 0;
    },
    verificarAcrescimo() {
      if (this.formaPagamentoSelecionada.acrescimo) {
        if (this.formaPagamentoSelecionada.acrescimo > 0) {
          this.modalAplicarAcrescimo = true;
        }
      }
    },
    cancelarFechamento() {
      let total = this.$helper.cleanFormatReal(this.getOrdemServico.total)
      let acrescimo = this.$helper.cleanFormatReal(this.getOrdemServico.acrescimo)
      this.modalCancelarFechamento = false;
      this.formaPagamentoSelecionada = "";
      this.ordemServico.formas_pagamento = [];
      this.getOrdemServico.total = this.$helper.formatReal(parseFloat(total - acrescimo));
      this.getOrdemServico.acrescimo = '0,00';
      this.acrescimosAplicados = [];
      this.valorPago = 0;
      this.getOrdemServico.troco = 0;
      this.valorFaltando = 0;
      this.setModalPagamentoOrdemServico(false)
    },

    focus(InputId) {
      document.getElementById(InputId).focus();
    },
  },
  created() {
    this.listarFormaPagamento();
  },
};
</script>